import React from 'react'

const PreparedTab = (props) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill={props ? props.color : '#FFFFFF'}
         xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.66656 8.0405L11.4712 4.23584L10.5286 3.29317L7.66656 6.15517L6.1379 4.62651L5.19523 5.56917L7.66656 8.0405Z"
        />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M12.3333 0.333496H4.33325C3.59792 0.333496 2.99992 0.931496 2.99992 1.66683V9.66683C2.99992 10.4022 3.59792 11.0002 4.33325 11.0002H12.3333C13.0686 11.0002 13.6666 10.4022 13.6666 9.66683V1.66683C13.6666 0.931496 13.0686 0.333496 12.3333 0.333496ZM4.33325 9.66683V1.66683H12.3333L12.3346 9.66683H4.33325Z"
        />
        <path
            d="M1.66659 4.3335H0.333252V12.3335C0.333252 13.0688 0.931252 13.6668 1.66659 13.6668H9.66659V12.3335H1.66659V4.3335Z"
        />
    </svg>
)

export default PreparedTab
